import * as React from 'react';
import { Block } from 'emotion-jsxstyle';
import { EntityActions, EntityType } from 'common/entity';
import { AppState } from 'common/models/AppState';
import { InfiniteList } from 'common/components/InfiniteList';
import { Member } from 'common/api/models/Member';
import { EligibleItemMapping } from 'common/api/models/EligibleItem';
import { Loading } from 'common/components/Loading';
import { VoucherApi } from 'common/api/resources/Voucher';
import { DayDialog } from 'common/components/dialogs/DayDialog';
import { DropDownDialog } from 'common/components/dialogs/DropDownDialog';
import { ApplicationStatusDropDownDialog } from 'common/components/dialogs/ApplicationStatusDropDownDialog';
import { ConfirmDialog } from 'common/components/dialogs/ConfirmDialog';
import { RowActionButton } from 'common/components/RowActionButton';
import { VoucherCancelDialog } from 'common/components/dialogs/VoucherCancelDialog';
import { AlertDialog } from 'common/components/dialogs/AlertDialog';
import { CertificatePackageSentDateDialog } from 'common/components/dialogs/CertificatePackageSentDateTimeDialog';

export interface MembersCertificationsProps {
  appState: AppState;
  entityActions: EntityActions;
  member?: Member;
  onEdit: (org: Member) => void;
}
export interface MembersCertificationsState {
  isLoading: boolean;
  eligibleItems: any[];
  next?: number;
  error?: string;
  extendEligibleUser?: Member;
  voucherId?: string;
  resendWelcomeEmailVoucher?: any;
  cancelExamDialog?: any;
  certificateDateTimeDialog?: any;
  open?: any;
  expireDate?: string;
  originalExpireDate?: string;
  member?: Member;
  drawingStatus?: string;
  applicationStatus?: string;
  voucher?: any;
  cancelReasonNoteAlert?: string;
}

export class MembersCertifications extends React.Component<MembersCertificationsProps, MembersCertificationsState> {
  state: MembersCertificationsState = { isLoading: false, eligibleItems: [], voucherId: '' };

  componentDidMount() {
    this.reload();
  }

  reload = () => {
    if (this.props.member) {
      this.props.entityActions.refetch(EntityType.MEMBER, this.props.member!.id!);
      this.setState({ isLoading: true });
      VoucherApi.getVouchersByMember(this.props.member!.id!, 'certification')
        .then(res => {
          // this.reload();
          let vouchers = Object.keys(res).map(key => [Number(key), res[key]]);
          this.setState({ isLoading: false, eligibleItems: vouchers });
        })
        .catch(e => {
          this.setState({ error: e.response.data.message });
          this.setState({ isLoading: false });
        });
    }
  };

  resendWelcomeEmail = () => {
    this.setState({ isLoading: true });
    VoucherApi.resendwelcomeemail(this.state.resendWelcomeEmailVoucher.id)
      .then(res => {
        this.setState({ resendWelcomeEmailVoucher: undefined, isLoading: false });
        // this.reload();
      })
      .catch(e => {
        this.setState({ error: e.response.data.message, isLoading: false });
      });
  };

  cancelVoucherDialogOnSave = () => {
    this.closeDialogModals();
    this.reload();
  };

  // cancelExam = () => {
  //   VoucherApi.cancelVoucher(this.state.voucherId!)
  //     .then(() => {
  //       this.setState({
  //         voucherId: undefined,
  //       });
  //       this.reload();
  //     })
  //     .catch(e => {
  //       this.setState({ isLoading: false });
  //     });
  // };

  closeDialogModals = () => {
    this.setState({
      extendEligibleUser: undefined,
      voucherId: undefined,
      drawingStatus: undefined,
      applicationStatus: undefined,
      resendWelcomeEmailVoucher: undefined,
      cancelExamDialog: undefined,
      certificateDateTimeDialog: undefined,
      cancelReasonNoteAlert: '',
    });
  };

  openExtendExamDialog = (voucher: any, voucherId: any, expireDate: any, originalExpireDate: any) => {
    this.setState({
      extendEligibleUser: voucher,
      voucherId: voucherId,
      expireDate: expireDate,
      originalExpireDate: originalExpireDate,
    });
  };
  openCancelExamDialog = (voucher: any) => {
    this.setState({
      cancelExamDialog: voucher,
    });
  };
  openCertificateDateTimeDialog = (voucher: any) => {
    this.setState({
      certificateDateTimeDialog: voucher,
    });
  };
  openResendWelcomeEmailDialog = (voucher: any) => {
    this.setState({
      resendWelcomeEmailVoucher: voucher,
    });
  };
  openUpdateDrawingStatusDialog = (voucher: any, voucherId: any, drawingStatus: any) => {
    this.setState({
      voucher: voucher,
      voucherId: voucherId,
      drawingStatus: drawingStatus,
    });
  };
  openUpdateApplicationStatusDialog = (voucher: any, voucherId: any, applicationStatus: any) => {
    this.setState({
      voucher: voucher,
      voucherId: voucherId,
      applicationStatus: applicationStatus,
    });
  };

  displayCancelledReasonNote = (voucher: any) => {
    this.setState({ cancelReasonNoteAlert: voucher.cancelledReasonNote });
  };

  reloadAfterSave = () => {
    this.closeDialogModals();
    this.reload();
  };

  render() {
    // const { isLoading } = this.state;
    return (
      <Block marginBottom="2rem">
        <InfiniteList hasMore={!!this.state.next} isLoading={this.state.isLoading} onLoadMore={this.reload}>
          <table
            className="table table-striped table-hover table-clickable"
            style={{ width: '100%' }}
            data-testid="membersCertifications"
          >
            <thead>
              <tr>
                <th>Product Name</th>
                <th>WC Order ID</th>
                <th>Application status</th>
                <th>Exam code</th>
                <th>Exam status</th>
                <th>Failed Count</th>
                <th>Drawing Status</th>
                <th>Expiration</th>
                <th>Cancel Reason</th>
                <th>Shipment</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {!this.state.isLoading &&
                !this.state.error &&
                this.state.eligibleItems.length === 0 && (
                  <tr>
                    <td colSpan={10}>No results found.</td>
                  </tr>
                )}
              {this.state.error && (
                <tr>
                  <td colSpan={9}>
                    <div className="alert alert-danger">{this.state.error}</div>
                  </td>
                </tr>
              )}

              {this.state.eligibleItems.length > 0 &&
                this.state.eligibleItems.length &&
                this.state.eligibleItems.map((u, i) => {
                  return u.map((item: EligibleItemMapping, index: number) => {
                    let examCode = '';
                    let examStatus = '';
                    let passFail = '';
                    let allowDrawingStatusUpdate = true;
                    let failedCount = 0;
                    if (item.drawingStatus === 'DRAWING_EXAM_PASSED' || item.drawingStatus === 'DRAWING_EXAM_FAILED') {
                      allowDrawingStatusUpdate = false;
                    }
                    if (item.kryterionExams) {
                      item.kryterionExams!.map(exam => {
                        examCode = exam.examCode!;
                        examStatus = exam.status!;
                        passFail = exam.passFail!;
                        if (passFail && passFail.length > 0) {
                          examStatus = passFail;
                        }
                        if (passFail && passFail === 'FAIL') {
                          failedCount++;
                        }
                      });
                    }
                    return (
                      item.productName &&
                      item.wcOrderId && (
                        <tr key={index}>
                          <td> {item.productName} </td>
                          <td> {item.wcOrderId} </td>

                          <td>
                            {item.applicationStatus} <br />
                            {item.applicationStatus &&
                              item.applicationStatus !== 'APPROVED' && (
                                <>
                                  <span
                                    className="badge badge-pill badge-success"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() =>
                                      this.openUpdateApplicationStatusDialog(u, item.id, item.applicationStatus)
                                    }
                                  >
                                    <i className="fa fa-edit ml-2" />
                                    <span> Update</span>
                                  </span>
                                </>
                              )}
                          </td>

                          <td> {examCode} </td>
                          <td>
                            {examStatus} <br />
                            {/* {examStatus &&
                              examStatus !== 'CANCELLED' && (
                                <>
                                  <span
                                    className="badge badge-pill badge-danger"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => this.openCancelExamDialog(item.id)}
                                  >
                                    <i className="fa fa-ban ml-2" />
                                    <span> Cancel</span>
                                  </span>
                                </>
                              )} */}
                          </td>
                          <td>{failedCount}</td>
                          <td>
                            {item.drawingStatus && item.drawingStatus!.replace(/_/g, ' ')} <br />
                            {examStatus === 'PASS' &&
                              allowDrawingStatusUpdate && (
                                <>
                                  <span
                                    className="badge badge-pill badge-success"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => this.openUpdateDrawingStatusDialog(u, item.id, item.drawingStatus)}
                                  >
                                    <i className="fa fa-edit ml-2" />
                                    <span> Update</span>
                                  </span>
                                </>
                              )}
                          </td>
                          <td>
                            {item.expireDate!.substring(0, item.expireDate!.indexOf('T'))} <br />
                            {examStatus !== 'CANCELLED' && (
                              <>
                                <span
                                  className="badge badge-pill badge-primary"
                                  style={{ cursor: 'pointer' }}
                                  onClick={() =>
                                    this.openExtendExamDialog(u, item.id, item.expireDate, item.originalExpireDate)
                                  }
                                >
                                  <i className="fa fa-arrow-circle-right ml-2" />
                                  <span> Extend</span>
                                </span>
                              </>
                            )}
                          </td>
                          <td>
                            {item.cancelledReason && item.cancelledReason!.replace(/_/g, ' ')}
                            {item.cancelledReason &&
                              item.cancelledReason === 'CANCELLED_MANUALLY' && (
                                <>
                                  <i
                                    className="fa fa-info-circle ml-2"
                                    onClick={() => this.displayCancelledReasonNote(item)}
                                  />
                                </>
                              )}
                          </td>
                          <td>
                            {item.certificationPackageSentDate &&
                              item.certificationPackageSentDate!.substring(0, item.expireDate!.indexOf('T'))}
                          </td>
                          <td>
                            <RowActionButton
                              item={item}
                              icon="envelope-o"
                              onClick={this.openResendWelcomeEmailDialog}
                            />
                            <span>&nbsp;</span>
                            <RowActionButton item={item} icon="ban" onClick={this.openCancelExamDialog} />
                            {item.drawingStatus &&
                              item.drawingStatus === 'DRAWING_EXAM_PASSED' && (
                                <>
                                  <span>&nbsp;</span>
                                  <RowActionButton
                                    altText="Certification Package Sent Date"
                                    item={item}
                                    icon="calendar-check-o"
                                    onClick={this.openCertificateDateTimeDialog}
                                  />
                                </>
                              )}
                          </td>
                        </tr>
                      )
                    );
                  });
                })}

              {this.state.isLoading && (
                <tr>
                  <td colSpan={10}>
                    <Loading />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </InfiniteList>

        {/* <ConfirmDialog
          title="Cancel Exam"
          message={`Are you sure you want to cancel this exam?`}
          isOpen={!!this.state.voucherId}
          onConfirm={this.cancelExam}
          onCancel={this.closeDialogModals}
          error={this.state.error}
          loadingMessage="Sending..."
        /> */}

        <DropDownDialog
          title="Update Drawing Status"
          isOpen={!!this.state.drawingStatus}
          voucher={this.state.voucherId!}
          member={this.state.member}
          onSave={this.reloadAfterSave}
          onCancel={this.closeDialogModals}
          drawingStatus={this.state.drawingStatus}
        />

        <ApplicationStatusDropDownDialog
          title="Update Application Status"
          isOpen={!!this.state.applicationStatus}
          voucher={this.state.voucherId!}
          member={this.state.member}
          onSave={this.reloadAfterSave}
          onCancel={this.closeDialogModals}
          applicationStatus={this.state.applicationStatus}
        />

        <DayDialog
          title="Extend Eligibility"
          isOpen={!!this.state.extendEligibleUser}
          voucher={this.state.voucherId!}
          member={this.state.member}
          expireDate={this.state.expireDate}
          originalExpireDate={this.state.originalExpireDate}
          onSave={this.reloadAfterSave}
          onCancel={this.closeDialogModals}
        />

        <ConfirmDialog
          title="Resend Welcome/Instructional Email"
          message={`Are you sure you want to resend the Welcome and Instruction email for this record?`}
          isOpen={!!this.state.resendWelcomeEmailVoucher}
          onConfirm={this.resendWelcomeEmail}
          onCancel={this.closeDialogModals}
          error={this.state.error}
          isLoading={this.state.isLoading}
          loadingMessage="Sending..."
        />

        <VoucherCancelDialog
          title="Cancel Exam"
          isOpen={!!this.state.cancelExamDialog}
          voucher={this.state.cancelExamDialog}
          onSave={this.cancelVoucherDialogOnSave}
          onCancel={this.closeDialogModals}
        />

        <AlertDialog
          isOpen={!!this.state.cancelReasonNoteAlert}
          title="Cancel Reason Note"
          message={this.state.cancelReasonNoteAlert ? this.state.cancelReasonNoteAlert : ''}
          onClose={this.closeDialogModals}
        />

        <CertificatePackageSentDateDialog
          isOpen={!!this.state.certificateDateTimeDialog}
          title="Certificate Package Sent Date"
          voucher={this.state.certificateDateTimeDialog}
          onSave={this.cancelVoucherDialogOnSave}
          onCancel={this.closeDialogModals}
        />
      </Block>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Members/MembersCertifications.tsx